export enum ACCESS_MODE {
  EDITOR = 'editor',
  VIEWER = 'viewer'
}

type TPayloadHandlers = { onSuccess?: () => void; onError?: (err) => void };

export type TCompanyWorkspace = { id: string; name: string; created_at: string };

export type TUserWorkspace = {
  workspace: {
    id: string;
    name: string;
    created_at: string;
  };
  access_mode: ACCESS_MODE;
};

export type TGetCompanyWorkspacesAction = {
  type: string;
  payload?: TPayloadHandlers;
};

export type TPutCompanyWorkspacesPayload = Array<TCompanyWorkspace>;

export type TPutCompanyWorkspacesAction = {
  type: string;
  payload: TPutCompanyWorkspacesPayload;
};

export type TGetUserWorkspacesAction = {
  type: string;
  payload?: TPayloadHandlers;
};

export type TPutUserWorkspacesPayload = Array<TUserWorkspace>;

export type TPutUserWorkspacesAction = {
  type: string;
  payload: TPutUserWorkspacesPayload;
};

export type TAddWorkspaceBody = {
  name: string;
};

export type TAddWorkspacePayload = {
  body: TAddWorkspaceBody;
} & TPayloadHandlers;

export type TAddWorkspaceAction = {
  type: string;
  payload: TAddWorkspacePayload;
};

export type TEditWorkspaceBody = {
  name: string;
};

export type TEditWorkspacePayload = {
  id: string;
  body: TEditWorkspaceBody;
} & TPayloadHandlers;

export type TEditWorkspaceAction = {
  type: string;
  payload: TEditWorkspacePayload;
};

export type TDeleteWorkspacePayload = {
  id: string;
} & TPayloadHandlers;

export type TDeleteWorkspaceAction = {
  type: string;
  payload: TDeleteWorkspacePayload;
};

export type TAccessItem = { id: string; username: string; email: string; access_mode: ACCESS_MODE };

type TAccessReducer = {
  isLoading: boolean;
  list: Array<TAccessItem>;
  workspaceName: string;
};

export type TWorkspacesReducer = {
  companyWorkspaces: Array<TCompanyWorkspace>;
  userWorkspaces: Array<TUserWorkspace>;
  isLoading: boolean;
  selected: TUserWorkspace | null;
  accesses: TAccessReducer;
};

export type TSetSelectedWorkspacePayload = TUserWorkspace;

export type TSetSelectedWorkspaceAction = {
  type: string;
  payload: TSetSelectedWorkspacePayload;
};

export type TGetWorkspaceAccessesPayload = {
  workspaceId: string;
} & TPayloadHandlers;

export type TGetWorkspacesAccessesAction = {
  type: string;
  payload: TGetWorkspaceAccessesPayload;
};

export type TPutWorkspaceAccessesPayload = { list: Array<TAccessItem>; workspaceId: string } & TPayloadHandlers;

export type TPutWorkspaceAccessesAction = {
  type: string;
  payload: TPutWorkspaceAccessesPayload;
};

export type TAddWorkspaceAccessBody = {
  email: string;
  accessMode: ACCESS_MODE;
};

export type TAddWorkspaceAccessPayload = {
  workspaceId: string;
  body: TAddWorkspaceAccessBody;
} & TPayloadHandlers;

export type TAddWorkspaceAccessAction = {
  type: string;
  payload: TAddWorkspaceAccessPayload;
};

export type TEditWorkspaceAccessBody = {
  accessMode: ACCESS_MODE;
};

export type TEditWorkspaceAccessPayload = {
  workspaceId: string;
  userId: string;
  body: TEditWorkspaceAccessBody;
} & TPayloadHandlers;

export type TEditWorkspaceAccessAction = {
  type: string;
  payload: TEditWorkspaceAccessPayload;
};

export type TDeleteWorkspaceAccessPayload = {
  workspaceId: string;
  userId: string;
} & TPayloadHandlers;

export type TDeleteWorkspaceAccessAction = {
  type: string;
  payload: TDeleteWorkspaceAccessPayload;
};
